import { render } from "./cart-drawer.vue?vue&type=template&id=21477f8c"
import script from "./cart-drawer.vue?vue&type=script&lang=js"
export * from "./cart-drawer.vue?vue&type=script&lang=js"

import "./cart-drawer.vue?vue&type=style&index=0&id=21477f8c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__